import { render, staticRenderFns } from "./InstructionalSettings.vue?vue&type=template&id=7c767e80"
import script from "./InstructionalSettings.vue?vue&type=script&lang=js"
export * from "./InstructionalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports